import React from 'react';
import { format } from 'date-fns';

function safeFormat(dateStr, fmt) {
  if (!dateStr) return '—';
  try { return format(new Date(dateStr), fmt); }
  catch { return '—'; }
}

export default function AboutModal({ onClose, version, latestScan }) {
  return (
    <div className="about-popover-wrap">
      <div className="about-popover">
        <button className="about-close" onClick={onClose}>✕</button>
        <div className="about-logo-wrap">
          <img src="/main_logo.jpeg" alt="Kayaker" className="about-logo" />
        </div>
        <div className="about-body">
          <div className="about-title">Kayak Education Finder</div>
          <div className="about-byline">by Kayaker Dov</div>
          {version && <div className="about-version">v{version}</div>}
          {latestScan && latestScan.end_timestamp && (
            <div className="about-freshness">
              Data updated {safeFormat(latestScan.end_timestamp, "MMM d, yyyy 'at' h:mm a")}
            </div>
          )}
          <p className="about-desc">
            Discover kayaking, canoeing, surfski and SUP education events across the
            USA, UK (including Wales), Mexico, Israel and Canada. Find classes, camps, seminars and symposiums from
            outfitters and clubs near you — or anywhere in the world.
          </p>
          <p className="about-desc">
            Browse events on a calendar, list or interactive map. Filter by discipline,
            country, date range and more. Click any event for full details including
            location, cost and a direct link to the outfitter.
          </p>
          <div className="about-disciplines">
            <span style={{color:'var(--sea)'}}>Sea Kayaking</span>
            <span style={{color:'var(--ww)'}}>Whitewater</span>
            <span style={{color:'var(--canoe)'}}>Canoe</span>
            <span style={{color:'var(--surfski)'}}>Surfski</span>
            <span style={{color:'var(--sup)'}}>SUP</span>
          </div>
        </div>
      </div>
    </div>
  );
}
